export default __webpack_public_path__ + "static/media/mewtwoAvatar.2d7ab8fa.png";